export { default, Banner } from './RetailPartnerBanner';
